import { cloneDeep, find, isNumber } from 'lodash'
import { setCookie } from '~/utils/helpers'

export const BLOCK_ALL = 'BLOCK_ALL'
export const MONTH_PRICE = 'MONTH_PRICE'
export const FULL_PRICE = 'FULL_PRICE'

const state = () => ({
  id: '',
  defaultConfig: {
    defaultProductId: 6145,
    additionalOptionsTypeId: 20,
    tempoTypeId: 19,
    teachingTypeId: 22,
    mainLearningObjId: 23
  },
  config: {},
  paramsModal: '',
  step: 1,
  dictionaries: [],
  productByCookie: {},
  techSpecializations: [],
  packets: [],
  packetSelected: null,
  selectedSettings: {},
  specializations: [
    {
      id: 0,
      code: '01',
      image_url: 'https://hb.bizmrg.com/frontend-scripts/assets/images/icon-select-in-learning.png',
      name: 'Выберу в процессе обучения',
      description: '',
      selected: true,
      disabled: false,
      settings: {},
      selectRule: BLOCK_ALL,
      state: []
    }
  ],
  paces: [],
  paceSelected: null,
  specializationsSelected: ['01'],
  options: [],
  optionsSelected: [],
  teachingTypes: [],
  learningObjectives: [],
  userInfo: {
    name: '',
    serName: '',
    email: '',
    phone: ''
  },
  formatPrice: MONTH_PRICE,
  branchesSelected: [],
  devicesSelected: [],
  learningTypeSelected: '',
  learningObjectivesSelected: [],
  additionalLearningObjectivesSelected: [],
  constructorParametersIds: [],
  stepFirst: {
    header: 'Шаг 1. Специализация',
    notification: {
      header: 'Вы можете выбрать одну или сразу две специализации, но тогда нагрузка будет выше',
      paragraph: 'Мы рекомендуем сделать выбор специализации после начала обучения, когда вы изучите особенности специализаций и поймете, какая подходит именно вам.'
    }
  },
  stepSecond: {
    header: 'Шаг 2. Пакет',
    rulesText: 'Шаг 2 будет доступен после заполнения шага 1',
    notification: {
      header: 'Зачем нужны пакеты?',
      paragraph: 'От пакета обучения зависит длительность програмы, учебный план и глубина знаний, которые вы получите. Пакет можно перевыбрать в процессе обучения.'
    }
  },
  stepThird: {
    header: 'Шаг 3. Темп обучения',
    rulesText: 'Шаг 3 будет доступен после заполнения шагов 1 и 2',
    notification: {
      header: '',
      paragraph: ''
    }
  },
  stepFourth: {
    header: 'Шаг 4. Дополнительно',
    rulesText: 'Шаг 4 будет доступен после заполнения шагов 1, 2 и 3',
    notification: {
      header: 'Дополнительные параметры',
      paragraph: 'Выбирать эти параметры не обязательно. Но если хотите выбрать — это здорово, потому что поможет нам максимально правильно подобрать для вас траекторию обучения.'
    }
  },
  directionName: ''
})

const mutations = {
  set(state, { type, payload }) {
    state[type] = payload
  }
}

const actions = {
  async getPackages({ commit }, params) {
    try {
      const data = await this.$api.curriculum.getPrice(params)
      const packages = []

      if (!data.isError && Array.isArray(data?.prices) && data.prices.length > 0) {
        const filtered = data.prices.reduce((o, i) => {
          if (!o.find(v => v.pim?.pimPackage?.code === i.pim?.pimPackage?.code)) {
            o.push(i)
          }

          return o
        }, [])

        if (!filtered[0].installmentPeriods.at(-1)) { return }

        filtered.forEach(item => {
          const packet = {}
          const arrIndex = item.installmentPeriods.at(-1)

          packet.price1 = arrIndex.installments[0].monthlyPayment
          packet.price2 = arrIndex.installments[1].monthlyPayment
          packet.priceFull = item.prices[1].value
          packet.priceDashed = item.prices[0].value

          const finded36price = find(item?.installmentPeriods, {
            period: 36
          })

          packet.price36 = finded36price?.installments[0]?.monthlyPayment * 36
          const discounts = item.discounts * 36

          const baseDiscount = find(discounts, {
            type: 'baseDiscount',
            valueType: 'percent'
          })

          if (baseDiscount) {
            packet.baseDiscount = baseDiscount.value
          } else {
            packet.baseDiscount = 0
          }

          const fullPaymentDiscount = find(discounts, {
            type: 'fullPaymentDiscount',
            valueType: 'percent'
          })

          if (fullPaymentDiscount) {
            packet.fullPaymentDiscount = fullPaymentDiscount.value
          } else {
            packet.fullPaymentDiscount = 0
          }

          packet.name = item?.pim?.pimPackage?.name || ''
          packet.description = item?.pim?.pimPackage?.description || ''
          packet.level = item?.pim?.pimPackage?.level || ''
          packet.diploma = item?.pim?.pimPackage?.diploma || ''
          packet.diplomaDescription = item?.pim?.pimPackage?.diplomaDescription || ''
          packet.duration = item?.pim?.pimPackage?.duration || ''
          packet.code = item?.pim?.pimPackage?.code || ''
          packet.durationDescription = item?.pim?.pimPackage?.durationDescription || ''
          packet.employment = item?.pim?.pimPackage?.employment || ''
          packet.employmentDescription = item?.pim?.pimPackage?.employmentDescription || ''
          packet.weight = item?.pim?.pimPackage?.weight || 0
          packet.id = item.productId
          packet.pimPackageId = item?.pim?.pimPackage?.id
          packet.jsonDescription = item?.pim?.pimPackage?.jsonDescription
          packet.landingLabel = item?.pim?.pimPackage?.landingLabel

          packages.push(packet)
        })
      }

      let newArr

      if (packages.length > 1) {
        newArr = packages.sort((a, b) => b.weight - a.weight).filter(p => p.name !== 'Не выбран')
      } else {
        newArr = packages
      }

      commit('set', { type: 'packets', payload: newArr })
    } catch (e) {
      console.warn(e)
    }
  },

  async sendOrder(params = {}) {
    const payload = {
      ...params
    }

    try {
      const { ref, newProductId } = await this.$api.curriculum.sendOrder(payload)
      const oneYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString()
      if (ref) { setCookie('gb_land_ref', ref, { secure: true, expires: oneYear }) }
      if (newProductId) { setCookie('gb_land_product_id', newProductId, { secure: true, expires: oneYear }) }
    } catch (e) {
      return Promise.reject(e)
    }
  },

  async createClaim(payload = {}) {
    await this.$api.curriculum.createClaim(payload)
  },

  async getSpecializations({ commit, state }, code) {
    const data = (await this.$api.curriculum.getSpecializationsByCode(code)) || []
    const dictSpecializations = state.specializations
    const newSpecializations = []

    data.forEach(item => {
      const findItem = find(dictSpecializations, {
        code: item.code
      })

      if (findItem) {
        const rules = []
        item.items.forEach(it => {
          rules.push(it?.id)
        })
        newSpecializations.push({ ...findItem, ...item, rules })
      } else {
        const dopOpt = {
          description: '',
          selected: false,
          disabled: false,
          settings: {},
          selectRule: null,
          state: []
        }
        const rules = []
        item.items.forEach(it => {
          rules.push(it?.id)
        })
        newSpecializations.push({ ...item, ...dopOpt, rules })
      }
    })

    newSpecializations.sort((a, b) => parseFloat(a.code) - parseFloat(b.code))

    commit('set', { type: 'specializations', payload: newSpecializations })
  },

  async getPriceByCookie({ commit }, productId) {
    try {
      const data = await this.$api.curriculum.getPrice(productId)
      commit('set', { type: 'productByCookie', payload: data })

      return data
    } catch (e) {
      console.warn(e)
    }
  },

  async getTechSpecializations({ commit }) {
    try {
      const data = await this.$api.curriculum.getTechSpecializations()
      commit('set', { type: 'techSpecializations', payload: data })
    } catch (e) {
      console.warn(e)
    }
  }
}

const getters = {
  dictTechSpecializations(state) {
    return state.techSpecializations
  },

  getStep(state) {
    return state.step
  },

  getSpecializations(state) {
    return state.specializations
  },

  getPriceFormat(state) {
    return state.formatPrice
  },

  getPackets(state) {
    return state.packets
  },

  getSelectedPacket(state) {
    return state.packetSelected
  },

  getPaces(state) {
    return state.paces
  },

  getUserInfo(state) {
    return state.userInfo
  },

  getSpecializationSelected(state) {
    return state.specializationsSelected.length > 0
  },

  getSelectedItemsDict(state) {
    const selectedIdsState = []
    const selectedCode = []
    state.specializations.forEach(item => {
      if (
        item.state.length > 0 &&
        state.specializationsSelected.includes(item.code)
      ) {
        selectedIdsState.push(item.state)
        selectedCode.push(item.code)
      }
    })
    let textObj = []
    const textedIdsState = []
    let a = 0
    if (selectedIdsState.length > 0) {
      selectedIdsState.forEach(item => {
        item.forEach(i => {
          const findEd = find(state.dictionaries, {
            id: i.dictionary
          })
          if (findEd) {
            const itemsTextArray = []
            i.ids.forEach(it => {
              const findEdItems = find(findEd.items, {
                id: it
              })
              if (findEdItems) {
                itemsTextArray.push(findEdItems.name)
              }
            })
            textObj = {
              code: selectedCode[a],
              name: findEd.name,
              items: itemsTextArray
            }
            textedIdsState.push(textObj)
          }
        })
        a++
      })
    }

    return textedIdsState
  },

  getConstructorParametersIds(state) {
    const selectedIdsState = []
    const constructorParametersIds = []
    state.specializations.forEach(item => {
      if (
        item.state.length > 0 &&
        state.specializationsSelected.includes(item.code)
      ) {
        selectedIdsState.push(item.state)
      }
    })

    if (selectedIdsState.length > 0) {
      selectedIdsState.forEach(item => {
        item.forEach(i => {
          const findEd = find(state.dictionaries, {
            id: i.dictionary
          })
          if (findEd) {
            i.ids.forEach(it => {
              const findEdItems = find(findEd.items, {
                id: it
              })
              if (findEdItems) {
                constructorParametersIds.push(it)
              }
            })
          }
        })
      })
    }

    return constructorParametersIds
  },

  getSelectedSpecialization(state) {
    return state.specializationsSelected
  },

  getSelectedSettings(state) {
    return state.selectedSettings
  },

  getLearningObjectiveText(state) {
    const text = []
    state.learningObjectives
      .filter(item => state.learningObjectivesSelected.includes(item.id))
      .map(i => text.push(i.name))

    return state.learningObjectivesSelected.length === 0
      ? 'Выберите основные цели обучения'
      : text.join(', ')
  },

  getBranchesSelected(state) {
    return state.branchesSelected
  },

  getPacketMonthPrice(state) {
    if (!isNumber(state.packetSelected)) {
      return 0
    }
    const packet = find(state.packets, {
      id: state.packetSelected
    })

    return packet?.price2 || 0
  },

  getSelectedSpecializationText(state) {
    let text = ''
    state.specializations.forEach(item =>
      state.specializationsSelected.includes(item.code)
        ? (text = text + item.name + ', ')
        : ''
    )

    return text.trim().slice(0, -1)
  },

  getBranchesSelectedText(state) {
    const branchesTextDefault = 'Выберите отрасль'
    const text = []
    const branchesSelected = cloneDeep(state.branchesSelected) || []
    const all = find(state.dictionaries, {
      id: 21
    })
    // eslint-disable-next-line
    branchesSelected.forEach(id => {
      const itemObject = find(all?.items, {
        id
      })
      text.push(itemObject.name)
    })

    return state.branchesSelected.length < 1
      ? branchesTextDefault
      : text.join(', ')
  },

  getLearningObjectivesSelected(state) {
    return state.learningObjectivesSelected
  },

  getFirstStepData(state) {
    return {
      header: state.config?.step1?.title || state.stepFirst.header,
      notification: {
        header: state.config?.step1?.desc_bold || state.stepFirst.notification.header,
        paragraph: state.config?.step1?.desc || state.stepFirst.notification.paragraph,
        type: 'static',
        isStatic: true
      }
    }
  },

  getSecondStepData(state) {
    return {
      header: state.config?.step2?.title || state.stepSecond.header,
      notification: {
        header: state.config?.step2?.desc_bold || state.stepSecond.notification.header,
        paragraph: state.config?.step2?.desc || state.stepSecond.notification.paragraph,
        linkText: state.id === 'it' ? 'Подробнее про пакеты и их сравнение' : '',
        type: 'static',
        isStatic: true
      }
    }
  },

  getThirdStepData(state) {
    return {
      header: state.config?.step3?.title || state.stepThird.header,
      notification: {
        header: state.config?.step3?.desc_bold || state.stepThird.notification.header,
        paragraph: state.config?.step3?.desc || state.stepThird.notification.paragraph,
        type: 'static',
        isStatic: true
      }
    }
  },

  getFourthStepData(state) {
    return {
      header: state.config?.step4?.title || state.stepFourth.header,
      notification: {
        header: state.config?.step4?.desc_bold || state.stepFourth.notification.header,
        paragraph: state.config?.step4?.desc || state.stepFourth.notification.paragraph,
        type: 'static',
        isStatic: true
      }
    }
  },

  getDictionaries(state) {
    return state.dictionaries
  },

  getSelectedPace(state) {
    return state.paceSelected
  },

  getSelectedOptions(state) {
    return state.optionsSelected
  },

  getOption(state) {
    return state.options
  },

  getSelectedPacketObj(state) {
    return find(state.packets, {
      id: state.packetSelected
    })
  },

  getSelectedLearningType(state) {
    return state.learningTypeSelected
  },

  getPacketName(state) {
    if (!isNumber(state.packetSelected)) {
      return ''
    }
    const packet = find(state.packets, {
      id: state.packetSelected
    })

    return packet?.name || ''
  },

  getSumPrice(state) {
    const selected = find(state.packets, {
      id: state.packetSelected
    })

    return selected?.price2
  },

  getSumPriceDashed(state) {
    const selected = find(state.packets, {
      id: state.packetSelected
    })

    return selected?.priceDashed
  },

  getDescriptionDevices(state) {
    const all = find(state.dictionaries, {
      id: 3
    })

    return all?.description
  },

  getTeachingTypes(state) {
    return state.teachingTypes
  },

  getLearningObjectives(state) {
    return state.learningObjectives
  },

  getPriceInCheckInt() {
    const id = document.getElementById('priceInCheck')

    return id?.innerText?.trim()
  },

  getLearningObjectivesTxt(state) {
    return getters.getLearningObjectiveText(state) ===
      'Выберите основные цели обучения'
      ? null
      : getters.getLearningObjectiveText(state).toLowerCase()
  },

  getBranchTxt(state) {
    return getters.getBranchesSelectedText(state) !== 'Выберите отрасль'
      ? getters.getBranchesSelectedText(state).toLowerCase()
      : null
  },

  getLearningTypeTxt(state) {
    return state.learningTypeSelected
      ? state.learningTypeSelected.toLowerCase()
      : null
  },

  getPackageCode(state) {
    const selectedPackage = getters.getSelectedPacketObj(state)

    return selectedPackage?.code ? `${selectedPackage?.code.toLowerCase()}` : ''
  }
}

export {
  state,
  getters,
  actions,
  mutations
}
